<div class="dialog__body dialog__body--check-result">
  <!-- プログレスバー -->
  <div class="az-check__progress">
    <div class="az-check__progress-bar">
      <div
        class="az-check__progress-bar-fill"
        [style.width.%]="jobAzCheckService.getProgressPercent()"
      ></div>
    </div>
    <span class="az-check__progress-label">
      {{ jobAzCheckService.getPassedCount() }} / {{ jobAzCheckService.checkResult?.totalFieldsCount }}完了
    </span>
  </div>

  <!-- 企画相談内容表示（表示のみ・編集不可） -->
  <div
    class="az-check__consultation-info"
    [class.az-check__consultation-info--accepted]="section.consultingInfo.middlePermissionFlg === 1"
    [class.az-check__consultation-info--rejected]="section.consultingInfo.middlePermissionFlg === 0"
    [class.az-check__consultation-info--ra-consultation]="isCompanyConsultation(section.consultingInfo.savedTiming)"
    *ngFor="let section of consultationInfoSections"
  >
    <h3 class="az-check__consultation-info-title">{{ section.title }}</h3>
    <ag-job-az-check-consulting-info
      [consultingInfo]="section.consultingInfo"
      [showMiddlePermissionResult]="!isCompanyConsultation(section.consultingInfo.savedTiming)"
      [showDescription]="!isCompanyConsultation(section.consultingInfo.savedTiming)"
    ></ag-job-az-check-consulting-info>
  </div>

  <!-- 賃金チェック表示 -->
  <div class="az-check__wage" *ngIf="['normal', 'oc'].includes(jobAzCheckService.selectedCategory)">
    <h3 class="az-check__wage-title">賃金チェック</h3>
    <!-- 入力欄 -->
    <div class="az-check__wage-input">
      <div class="az-check__wage-input-main">
        <div class="az-check__wage-field">
          <span class="az-check__wage-label">みなし労働時間制の有無</span>
          <ag-select
            class="az-check__wage-select"
            [options]="workhourTypeOptions"
            [(ngModel)]="workhourType"
            (valueChange)="onFormChanged()"
          ></ag-select>
        </div>

        <div class="az-check__wage-field">
          <span class="az-check__wage-label">1日のみなし労働時間</span>
          <input
            type="number"
            [(ngModel)]="dynamicData.deemedDailyWorkingHours"
            [disabled]="!hasDeemedWorkingHoursSystem"
            (input)="onFormChanged()"
          />
          <span class="az-check__wage-unit">時間</span>
        </div>

        <div class="az-check__wage-field">
          <span class="az-check__wage-label">年間休日</span>
          <input
            type="number"
            [(ngModel)]="dynamicData.annualHolidays"
            (input)="onFormChanged()"
          />
          <span class="az-check__wage-unit">日</span>
        </div>

        <div class="az-check__wage-field">
          <span class="az-check__wage-label">就業時間</span>
          <input
            type="time"
            [(ngModel)]="dynamicData.workingHourRange.from"
            (input)="onFormChanged()"
          />
          <span class="az-check__wage-range-separator">〜</span>
          <input
            type="time"
            [(ngModel)]="dynamicData.workingHourRange.to"
            (input)="onFormChanged()"
          />
        </div>

        <div class="az-check__wage-field">
          <span class="az-check__wage-label">休憩時間</span>
          <input
            type="text"
            [(ngModel)]="dynamicData.breakHour"
            (ngModelChange)="onFormChanged()"
            placeholder="例：60分"
          />
        </div>

        <div class="az-check__wage-section">
          <div class="az-check__wage-section-header">
            <span class="az-check__wage-label">月給</span>
            <button
              type="button"
              class="btn btn--blue btn--small"
              (click)="addSalaryPattern()"
            >
              + 種別追加
            </button>
          </div>

          <div class="az-check__wage-salary-row" *ngFor="let categoryKey of salaryCategoryKeys">
            <span class="az-check__wage-salary-category">{{ getGradCategoryLabel(categoryKey) }}</span>
            <input
              type="text"
              inputmode="numeric"
              class="amount"
              [ngModel]="dynamicData.salaryTable['salary_' + categoryKey]"
              (input)="onFormChangedWithApplyNumericInput($event, 'salary_' + categoryKey, dynamicData.salaryTable, '月給')"
            />
            <span class="az-check__wage-unit">円</span>
            <button
              type="button"
              class="btn btn--white btn--outline-gray btn--small"
              (click)="removeSalaryCategory(categoryKey)"
            >
              削除
            </button>
          </div>
        </div>

        <div class="az-check__wage-section">
          <div class="az-check__wage-section-header">
            <span class="az-check__wage-label">固定残業代</span>
            <button
              type="button"
              class="btn btn--blue btn--small"
              (click)="addFixedOvertimePattern()"
              (input)="onFormChanged()"
              [disabled]="!hasFixedOvertimeFee"
            >
              + 種別追加
            </button>
          </div>

          <div class="az-check__wage-salary-row" *ngFor="let categoryKey of fixedOvertimeCategoryKeys">
            <span class="az-check__wage-salary-category">{{ getGradCategoryLabel(categoryKey) }}</span>
            <input
              type="text"
              inputmode="numeric"
              class="hour"
              [ngModel]="dynamicData.salaryTable['fixedOvertimeHours_' + categoryKey]"
              (input)="onFormChangedWithApplyNumericInput($event, 'fixedOvertimeHours_' + categoryKey, dynamicData.salaryTable, '固定残業代補足')"
            />
            <span class="az-check__wage-unit">時間</span>
            <input
              type="text"
              inputmode="numeric"
              class="amount"
              [ngModel]="dynamicData.salaryTable['fixedOvertimeAmount_' + categoryKey]"
              (input)="onFormChangedWithApplyNumericInput($event, 'fixedOvertimeAmount_' + categoryKey, dynamicData.salaryTable, '固定残業代補足')"
            />
            <span class="az-check__wage-unit">円</span>
            <button
              type="button"
              class="btn btn--white btn--outline-gray btn--small"
              (click)="removeFixedOvertimeCategory(categoryKey)"
            >
              削除
            </button>
          </div>
        </div>

        <div class="az-check__wage-section" *ngIf="fixedLateNightOvertimeCategoryKeys.length > 0">
          <div class="az-check__wage-section-header">
            <span class="az-check__wage-label">固定深夜割増</span>
            <button
              type="button"
              class="btn btn--blue btn--small"
              (click)="addFixedLateNightOvertimePattern()"
            >
              + 種別追加
            </button>
          </div>

          <div class="az-check__wage-salary-row" *ngFor="let categoryKey of fixedLateNightOvertimeCategoryKeys">
            <span class="az-check__wage-salary-category">{{ getGradCategoryLabel(categoryKey) }}</span>
            <input
              type="text"
              inputmode="numeric"
              class="hour"
              [ngModel]="dynamicData.salaryTable['fixedLateNightOvertimeHours_' + categoryKey]"
              (input)="onFormChangedWithApplyNumericInput($event, 'fixedLateNightOvertimeHours_' + categoryKey, dynamicData.salaryTable, '固定の深夜割増手当')"
            />
            <span class="az-check__wage-unit">時間</span>
            <input
              type="text"
              inputmode="numeric"
              class="amount"
              [ngModel]="dynamicData.salaryTable['fixedLateNightOvertimeAmount_' + categoryKey]"
              (input)="onFormChangedWithApplyNumericInput($event, 'fixedLateNightOvertimeAmount_' + categoryKey, dynamicData.salaryTable, '固定の深夜割増手当')"
            />
            <span class="az-check__wage-unit">円</span>
            <button
              type="button"
              class="btn btn--white btn--outline-gray btn--small"
              (click)="removeFixedLateNightOvertimeCategory(categoryKey)"
            >
              削除
            </button>
          </div>
        </div>

        <div class="az-check__wage-field" *ngIf="dynamicData.monthlyScheduledWorkingHours != null">
          <span class="az-check__wage-label">月間所定労働時間</span>
          <input
            type="text"
            inputmode="numeric"
            [ngModel]="dynamicData.monthlyScheduledWorkingHours"
            (input)="onFormChangedWithApplyNumericInput($event, 'monthlyScheduledWorkingHours')"
          />
          <span class="az-check__wage-unit">時間</span>
          <button
            type="button"
            class="btn btn--white btn--outline-gray btn--small"
            (click)="removeOtherConditionWithKey('monthlyScheduledWorkingHours')"
          >
            削除
          </button>
        </div>

        <div class="az-check__wage-field" *ngIf="dynamicData.annualScheduledWorkingHours != null">
          <span class="az-check__wage-label">年間所定労働時間</span>
          <input
            type="text"
            inputmode="numeric"
            [ngModel]="dynamicData.annualScheduledWorkingHours"
            (input)="onFormChangedWithApplyNumericInput($event, 'annualScheduledWorkingHours')"
          />
          <span class="az-check__wage-unit">時間</span>
          <button
            type="button"
            class="btn btn--white btn--outline-gray btn--small"
            (click)="removeOtherConditionWithKey('annualScheduledWorkingHours')"
          >
            削除
          </button>
        </div>

        <div
          class="az-check__wage-field az-check__wage-field--radio"
          *ngIf="dynamicData.salaryTable.variableWorkingHoursSystem != null"
        >
          <span class="az-check__wage-label">変形労働時間制</span>
          <div>
            <label class="az-check__wage-radio-item" *ngFor="let option of variableWorkingHoursSystemOptions">
              <input
                type="radio"
                name="variableWorkingHoursSystem"
                [value]="option"
                [checked]="dynamicData.salaryTable.variableWorkingHoursSystem === option"
                (change)="onVariableWorkingHoursSystemChange(option)"
              />
              <span>{{ option }}</span>
            </label>
          </div>
          <button
            type="button"
            class="btn btn--white btn--outline-gray btn--small"
            (click)="removeOtherConditionWithKey('variableWorkingHoursSystem')"
          >
            削除
          </button>
        </div>

        <button
          type="button"
          class="btn btn--blue btn--small az-check__wage-add-condition"
          (click)="addOtherCondition()"
        >
          + その他の条件追加
        </button>
      </div>

      <div class="az-check__wage-input-prefecture">
        <span class="az-check__wage-label">勤務地(都道府県)</span>
        <ag-prefecture-area-select
          [(ngModel)]="dynamicData.workplacePrefectures"
          (valueChange)="onFormChanged()"
        >
        </ag-prefecture-area-select>
      </div>
    </div>

    <!-- 賃金チェック結果 -->
    <div class="az-check__wage-result" *ngFor="let group of jobAzCheckService.wageCheckFieldGroups">
      <h4 class="az-check__wage-result-title">{{ group.label }}</h4>

      <div class="az-check__wage-result-header">
        <div class="az-check__title-consultation">相談対象</div>
        <div class="az-check__wage-result-col az-check__wage-result-col--category">種別</div>
        <div class="az-check__wage-result-col">{{ group.details[0].requiredValueLabel }}</div>
        <div class="az-check__wage-result-col">{{ group.details[0].actualValueLabel }}</div>
        <div class="az-check__wage-result-col az-check__wage-result-col--judge">判定結果</div>
      </div>

      <ng-container *ngFor="let detail of group.details">
        <div class="az-check__wage-result-row">
          <label class="az-check__consultation">
            <input
              type="checkbox"
              [(ngModel)]="jobAzCheckService.consultationTargets[detail.field]"
            />
          </label>
          <div class="az-check__wage-result-col az-check__wage-result-col--category">
            {{ detail.gradCategory ? getDisplayGradCategoryLabel(detail.gradCategory) : '-' }}
          </div>
          <div class="az-check__wage-result-col">
            <ng-container *ngIf="detail.requiredValue != null; else requiredValueError">{{ detail.requiredValue | number:'1.0-2' }}{{ detail.unit }}</ng-container>
            <ng-template #requiredValueError>-</ng-template>
          </div>
          <div class="az-check__wage-result-col">
            <ng-container *ngIf="detail.actualValue != null; else actualValueError">{{ detail.actualValue | number:'1.0-2' }}{{ detail.unit }}</ng-container>
            <ng-template #actualValueError>計算エラー</ng-template>
          </div>
          <div class="az-check__wage-result-col az-check__wage-result-col--judge detail">{{ detail.message }}</div>
        </div>

        <!-- 計算式 -->
        <ag-wage-az-check-calculation-steps
          *ngIf="detail.calculationSteps.length > 0"
          [title]="getCalculationStepsTitle(group, detail)"
          [steps]="detail.calculationSteps"
        ></ag-wage-az-check-calculation-steps>
      </ng-container>
    </div>
  </div>

  <!-- セクションごとのフォーム表示 -->
  <div *ngFor="let section of jobAzCheckService.checkSections">
    <div class="az-check__section" *ngIf="jobAzCheckService.isDisplaySection(section)">
      <h3 class="az-check__section-title">{{ section.title }}</h3>

      <div class="az-check__field-header">
        <div class="az-check__title-consultation">相談対象</div>
        <div class="az-check__title-form">記載内容</div>
        <div class="az-check__title-validation">記載内容に対するコメント</div>
      </div>

      <div *ngFor="let row of section.rows">
        <div
          class="az-check__field-row"
          *ngIf="jobAzCheckService.isDisplayRow(row)"
          [class.az-check__field-row--error]="jobAzCheckService.getError(row.fieldKey)?.type === 'error'"
          [class.az-check__field-row--warning]="jobAzCheckService.getError(row.fieldKey)?.type === 'warning'"
        >
          <!-- 相談対象チェックボックス -->
          <label class="az-check__consultation">
            <input
              type="checkbox"
              [(ngModel)]="jobAzCheckService.consultationTargets[row.fieldKey]"
            />
          </label>

          <!-- フォームフィールドエリア -->
          <div class="az-check__form-area">
            <ag-dynamic-form
              class="az-check__form"
              [metadata]="row.formMeta"
              [model]="row.useCompanyModel ? jobAzCheckService.companyData : jobAzCheckService.job"
              (changed)="jobAzCheckService.onFormChanged($event, row, section.rows)"
              (actioned)="jobAzCheckService.onActioned($event.key, $event.actionType)"
              (validated)="jobAzCheckService.onValidityChange($event, row.fieldKey)"
            ></ag-dynamic-form>
          </div>

          <!-- コメント -->
          <div class="az-check__comment-area">
            <span
              class="az-check__comment"
              [class.az-check__comment--error]="jobAzCheckService.getError(row.fieldKey)?.type === 'error'"
              [class.az-check__comment--warning]="jobAzCheckService.getError(row.fieldKey)?.type === 'warning'"
            >
              {{ jobAzCheckService.getError(row.fieldKey)?.message }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 求人票プレビュー -->
  <div class="az-check__section">
    <h3 class="az-check__section-title">求人票プレビュー</h3>
    <p *ngIf="jobAzCheckService.previewPdfLoading">読み込み中...</p>
    <p *ngIf="jobAzCheckService.previewPdfError">プレビューの表示に失敗しました。時間をおいて再度お試しください。</p>
    <iframe
      *ngIf="previewPdfUrl"
      class="az-check__preview-pdf"
      [src]="previewPdfUrl"
    ></iframe>
  </div>
  <h3 class="az-check__section-title">見切れ、誤字チェック</h3>
  <div class="az-check__precheck">
    <label class="az-check__precheck-label">
      <input class="az-check__precheck-input" type="checkbox" [(ngModel)]="jobAzCheckService.pdfCheckAccepted" />
      <span class="az-check__precheck-text">PDFにて、「事業内容/職務内容/アピールポイント/その他」について、改行による見切れ（枠外へのはみ出し）が発生していないか、誤字脱字がないか、確認してください。</span>
    </label>
  </div>
</div>
